import MIcon from './MIcon.vue';

export { MIcon };
export default MIcon;
